import { TranslationScopes } from "@finbackoffice/enums";
import { SportTypesBC, SportTypes } from "@finbackoffice/fe-core";
import { FC, useMemo } from "react";
import { NavigationBarItem } from "components/base/navigation/NavigationBarItem";
import { RouteNames } from "utils/constants";

type PoliciesNavItemProps = {
    name: string;
    isBCFeed: boolean;
};

const CUSTOM_RULES_MAP = {
    GENERAL_RULES: { tid: "policies_sportsbook_betTypes", iconSvg: "policies-bet-types" },
    SECONDARY_RULES: {
        tid: "policies_sportsbook_settlement",
        iconSvg: "policies-settlement-cancellation",
    },
};

export const PoliciesNavItem: FC<PoliciesNavItemProps> = ({ name, isBCFeed }) => {
    const sports = useMemo(() => (isBCFeed ? SportTypesBC : SportTypes), [isBCFeed]);
    const isSport = useMemo(() => Object.keys(sports).includes(name), [name, sports]);
    const sportId = useMemo(() => {
        if (!isSport) return;
        return sports[name as keyof typeof sports];
    }, [name, sports, isSport]);

    const customRules = useMemo(
        () => CUSTOM_RULES_MAP[name as keyof typeof CUSTOM_RULES_MAP],
        [name],
    );

    const translationData = useMemo(() => {
        const translationKey = isBCFeed ? `bc_sportrules_${name}_name` : customRules?.tid;
        return isSport
            ? { tid: `sport_${name.toLowerCase()}`, namespace: TranslationScopes.Common }
            : { tid: translationKey, namespace: TranslationScopes.PoliciesSportsbook };
    }, [name, isBCFeed, customRules, isSport]);

    const iconSvg = useMemo(() => {
        if (isSport) return;
        return isBCFeed
            ? `policies-${name.toLowerCase().replace(/_/g, "-")}`
            : customRules?.iconSvg;
    }, [name, isBCFeed, customRules, isSport]);

    return (
        <NavigationBarItem
            type="link"
            active={false}
            isSelected={false}
            href={`/${RouteNames.POLICIES}/${RouteNames.SPORTSBOOK}/${name.toLowerCase().replace(/_/g, "-")}`}
            variant="base"
            translationData={translationData}
            sportIconId={sportId}
            svgIconSrc={iconSvg}
        />
    );
};
